(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["mc-newsletter-popup"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function showPopup () {
        $('#mc_newsletter_popup').addClass('mc-newsletter-popup-wrapper--visible')
        $('#mc_newsletter_popup_overlay').addClass('mc-newsletter-popup-overlay--visible')
        $('#newsletter_popup_close_button').click(function(e) {
          e.stopPropagation()
          $('#mc_newsletter_popup').removeClass('mc-newsletter-popup-wrapper--visible')
          $('#mc_newsletter_popup_overlay').removeClass('mc-newsletter-popup-overlay--visible')
        })
      }
    function showTaost () {
      $('#mc_newsletter_popup_toast').addClass('mc-newsletter-popup-toast--visible')
      setTimeout(() => {
        $('#mc_newsletter_popup_toast').removeClass('mc-newsletter-popup-toast-visible')
      }, 5000)
      
      $('#newsletter_popup_toast_close_button').click(function(e) {
        e.stopPropagation()
        $('#mc_newsletter_popup_toast').removeClass('mc-newsletter-popup-toast--visible')
      })
    }
    
    
    
    window.addEventListener('load', (event) => {
      const params = new Proxy(new URLSearchParams(window.location.search), {
        get: (searchParams, prop) => searchParams.get(prop),
      });
    
      if (params.newsletter === 'popup') showPopup()
      if (params.form_type === 'customer' && params['contact[tags]'].includes('popup')) showTaost() 
    });
  })();

  } catch(e) { console.error(e); }
})();
})();
